import cx from "classnames";
import React from "react";

import { getProgramBackgroundColorPicker } from "../../helpers/useProgramColorPicker";
import { Programs } from "../../models/programsConfig";
import * as styles from "./TestStyle.module.css";

type TestButtonLinkProps = Readonly<{
  title: string;
  url: string;
  type?: Programs;
}>;

export const TestButtonLink = ({ title, url, type }: TestButtonLinkProps) => {
  const styleClass = cx(
    styles.testButton,
    getProgramBackgroundColorPicker(type ?? Programs.IdXbox, true)
  );
  return (
    <div>
      <a className={styleClass} href={url} target="_blank" rel="noopener noreferrer">
        {title}
      </a>
      <br />
    </div>
  );
};
